<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-home </v-icon>
            Products
            <v-spacer />
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="productsForTable"
              v-model="selectedProducts"
              show-select
              item-key="ProductId"
              class="elevation-5"
              :item-class="itemRowBackground"
              :options.sync="productsTableOptions"
            >
              <template v-slot:header.data-table-select>
                <v-simple-checkbox
                  color="primary"
                  :value="allVisibleCopyableSelected"
                  :indeterminate="
                    someVisibleCopyableSelected && !allVisibleCopyableSelected
                  "
                  :disabled="!visibleCopyableProducts.length"
                  :ripple="false"
                  @click.stop.prevent="toggleSelectAllCopyable"
                ></v-simple-checkbox>
              </template>
              <template v-slot:item.data-table-select="{ item }">
                <v-simple-checkbox
                  v-if="isProductCopyable(item)"
                  :value="isProductSelected(item)"
                  color="primary"
                  :ripple="false"
                  @click.stop.prevent="toggleProductSelected(item)"
                ></v-simple-checkbox>
              </template>
              <template v-slot:item.TagIds="{ item }">
                {{
                  item.TagIds
                    ? handleCheckTags(item.TagIds)
                        .map((tag) => tag.ProductTagName)
                        .join(", ")
                    : ""
                }}
              </template>
              <template v-slot:item.CategoryName="{ item }">
                {{ getCategoryName(item.CategoryId) }}
              </template>
              <template v-slot:item.DiscountSurchargePercentage="{ item }">
                {{
                  item.DiscountSurchargePercentage === 0
                    ? ""
                    : item.DiscountSurchargePercentage
                }}
              </template>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-row>
                    <v-row class="mt-2">
                      <v-col cols="4">
                        <v-autocomplete
                          :items="currentStallHolders"
                          v-model="selectedStallHolder"
                          item-text="StallholderName"
                          return-object
                          filled
                          dense
                          outlined
                          hide-details
                          label="StallHolders"
                          @change="handleChangeStallHolder"
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-title>
                                <v-icon small color="red lighten-1">
                                  mdi-information
                                </v-icon>
                                No event found
                              </v-list-item-title>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="4">
                        <v-combobox
                          filled
                          dense
                          outlined
                          v-model="selectedCategoryFilter"
                          :items="categoryFilterList"
                          label="Filter by Category"
                          item-text="CategoryName"
                          item-value="CategoryId"
                          return-object
                          clearable
                        >
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-row>

                  <v-btn
                    v-if="IsAdmin"
                    small
                    dark
                    class="mb-2 mr-2"
                    :disabled="!selectedEvent || !selectedEvent.EventId"
                    @click="importDialog = true"
                  >
                    <v-icon left x-small> mdi-upload </v-icon>
                    Import Products
                  </v-btn>

                  <v-btn
                    v-if="canManageProducts"
                    small
                    dark
                    class="mb-2 mr-2"
                    :disabled="
                      !selectedStallHolder.StallholderId ||
                      selectedProductIds.length === 0
                    "
                    @click="copyDialog = true"
                  >
                    <v-icon left x-small> mdi-content-copy </v-icon>
                    Copy to…
                  </v-btn>

                  <v-dialog v-model="dialog" max-width="800px" dark>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="canManageProducts"
                        small
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="!selectedStallHolder.StallholderId"
                      >
                        <v-icon left x-small> mdi-plus </v-icon>
                        Add Products
                      </v-btn>

                      <v-btn
                        v-if="canManageProducts"
                        :disabled="!selectedStallHolder.StallholderId"
                        @click="handleCreateIsCashOut"
                        class="mr-3 mb-2"
                        small
                        dark
                        v-bind:class="{ gray: !IsCashOut, green: IsCashOut }"
                        v-on:click="IsCashOut = !IsCashOut"
                      >
                        <v-checkbox
                          v-model="IsCashOut"
                          hide-details
                          v-on:click="IsCashOut = !IsCashOut"
                        ></v-checkbox>

                        Enable Cash Out
                      </v-btn>

                      <v-btn
                        v-if="canManageProducts"
                        :disabled="!selectedStallHolder.StallholderId"
                        @click="handleCreateManualProduct"
                        class="mr-3 mb-2"
                        small
                        dark
                        v-bind:class="{
                          gray: !ManualProduct,
                          green: ManualProduct,
                        }"
                        v-on:click="ManualProduct = !ManualProduct"
                      >
                        <v-checkbox
                          v-model="ManualProduct"
                          hide-details
                          v-on:click="ManualProduct = !ManualProduct"
                        ></v-checkbox>

                        Enable Manual Product
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h6">
                        {{ formTitle }}
                      </v-card-title>
                      <v-divider></v-divider>

                      <v-card-text>
                        <v-container>
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                              <v-col cols="6">
                                <label
                                  ><B>Event :-</B>
                                  {{
                                    selectedEvent.EventName
                                      ? selectedEvent.EventName
                                      : "N/A"
                                  }}</label
                                >
                              </v-col>
                              <v-col cols="6">
                                <label
                                  ><B>Stallholder :-</B>
                                  {{
                                    selectedStallHolder.StallholderName
                                      ? selectedStallHolder.StallholderName
                                      : "N/A"
                                  }}</label
                                >
                              </v-col>
                              <!-- <v-col cols="4">
                                    <label><B>Stall :-</B> {{ selectedStall.StallName ? selectedStall.StallName : 'N/A'}}</label>
                                </v-col> -->
                            </v-row>

                            <!-- Discount Surcharge Checkbox -->
                            <v-row>
                              <v-col cols="12">
                                <v-checkbox
                                  v-model="editedItem.DiscountSurchargeItem"
                                  label="Discount Surcharge Item"
                                  @change="toggleDiscountSurchargeFields"
                                ></v-checkbox>
                              </v-col>
                            </v-row>

                            <!-- Regular Product Fields -->
                            <v-row v-if="!editedItem.DiscountSurchargeItem">
                              <v-col cols="4">
                                <v-combobox
                                  v-model="editedItem.CategoryId"
                                  :items="CategoryList"
                                  label="Categories"
                                  item-text="CategoryName"
                                >
                                </v-combobox>
                              </v-col>
                              <v-col cols="4">
                                <v-combobox
                                  v-model="editedItem.TagIds"
                                  multiple
                                  :items="TagList"
                                  label="Tag"
                                  item-text="ProductTagName"
                                  item-value="ProductTagId"
                                  return-object
                                >
                                </v-combobox>
                              </v-col>
                              <v-col cols="4">
                                <v-combobox
                                  v-model="editedItem.ProductOptionIds"
                                  multiple
                                  :items="ProductOptionList"
                                  label="Product Options"
                                  item-text="ProductOptionName"
                                >
                                </v-combobox>
                              </v-col>
                            </v-row>

                            <v-text-field
                              v-model="editedItem.ProductName"
                              label="Product Name"
                              :rules="[
                                (v) => !!v || 'Product Name is required',
                              ]"
                              @input="onProductNameInput"
                            ></v-text-field>

                            <v-text-field
                              v-model="editedItem.ShortName"
                              label="Short Name"
                              :rules="[
                                (v) => !!v || 'Short Name is required',
                              ]"
                            ></v-text-field>

                            <!-- Discount Surcharge Specific Fields -->
                            <div v-if="editedItem.DiscountSurchargeItem">
                              <v-text-field
                                v-model="editedItem.DiscountSurchargePercentage"
                                type="number"
                                label="Discount Surcharge (%)"
                                :rules="[
                                  (v) =>
                                    !!v || 'Discount Surcharge (%) is required',
                                ]"
                              ></v-text-field>

                              <v-checkbox
                                v-model="editedItem.DiscountSurchargeManager"
                                label="Discount Surcharge Manager"
                              ></v-checkbox>
                            </div>

                            <!-- Regular Product Fields -->
                            <div v-if="!editedItem.DiscountSurchargeItem">
                              <v-text-field
                                v-model="editedItem.Price"
                                type="number"
                                label="Price"
                                :rules="[(v) => !!v || 'Price is required']"
                              ></v-text-field>

                              <v-text-field
                                v-model="editedItem.StandardDrinks"
                                type="number"
                                label="Standard Drinks"
                                :rules="[
                                  (v) =>
                                    (v !== null &&
                                      v !== undefined &&
                                      v !== '') ||
                                    'Standard Drinks is required',
                                ]"
                              ></v-text-field>

                              <v-btn
                                class="mr-3"
                                small
                                dark
                                v-bind:class="{
                                  gray: !editedItem.GstFlag,
                                  green: editedItem.GstFlag,
                                }"
                                v-on:click="
                                  editedItem.GstFlag = !editedItem.GstFlag
                                "
                              >
                                <v-checkbox
                                  class="mb-5"
                                  v-model="editedItem.GstFlag"
                                  hide-details
                                  v-on:click="
                                    editedItem.GstFlag = !editedItem.GstFlag
                                  "
                                ></v-checkbox>
                                GST Applicable
                              </v-btn>
                            </div>

                            <v-divider class="mt-5 mb-5"></v-divider>

                            <!-- Per-stall Short Name / Price overrides -->
                            <div
                              v-if="
                                !editedItem.DiscountSurchargeItem &&
                                !editedItem.ManualProduct &&
                                !editedItem.IsCashOut
                              "
                            >
                              <div class="text-subtitle-2 mb-2">
                                Stall overrides
                              </div>
                              <div class="text-caption grey--text mb-3">
                                Optional Short Name and Price for specific
                                stalls. Leave blank to use the product defaults
                                above.
                              </div>
                              <v-row
                                v-for="(item, index) in stallProducts"
                                :key="'stall-override-' + index"
                                align="center"
                              >
                                <v-col cols="12" sm="4" class="py-1">
                                  <v-autocomplete
                                    :items="availableStallsForOverride(index)"
                                    v-model="item.Stall"
                                    item-text="StallName"
                                    item-value="StallId"
                                    item-disabled="disabled"
                                    return-object
                                    dense
                                    outlined
                                    hide-details
                                    label="Stall"
                                    clearable
                                  >
                                    <template v-slot:no-data>
                                      <v-list-item>
                                        <v-list-item-title>
                                          No stalls available
                                        </v-list-item-title>
                                      </v-list-item>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="3" class="py-1">
                                  <v-text-field
                                    v-model="item.ShortName"
                                    dense
                                    outlined
                                    hide-details
                                    label="Short Name override"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" class="py-1">
                                  <v-text-field
                                    v-model="item.Price"
                                    type="number"
                                    dense
                                    outlined
                                    hide-details
                                    label="Price override"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2" class="py-1">
                                  <v-btn
                                    icon
                                    small
                                    color="red lighten-2"
                                    :disabled="stallProducts.length <= 1"
                                    @click="removeStallProductRow(index)"
                                  >
                                    <v-icon small>mdi-delete</v-icon>
                                  </v-btn>
                                  <v-btn
                                    v-if="index === stallProducts.length - 1"
                                    icon
                                    small
                                    color="primary"
                                    @click="addStallProductRow"
                                  >
                                    <v-icon small>mdi-plus</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- End of stall products -->

                            <!-- <v-row>
                                    <v-col cols="6">
                                        <label>Text Color</label>
                                        <v-color-picker
                                            dot-size="25"
                                            mode="hexa"
                                            hide-mode-switch
                                            swatches-max-height="150"
                                            v-model="editedItem.TextColor"
                                        ></v-color-picker>
                                    </v-col>
                                    <v-col cols="6">
                                        <label>Background Color</label>
                                        <v-color-picker
                                            dot-size="25"
                                            mode="hexa"
                                            hide-mode-switch
                                            swatches-max-height="150"
                                            v-model="editedItem.BackgroundColor"
                                        ></v-color-picker>
                                    </v-col>
                               </v-row> -->
                            <!-- </v-col> -->
                          </v-form>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">
                          Cancel
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="save">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog dark v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5"
                        >Are you sure you want to delete Product ?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete"
                          >Cancel</v-btn
                        >
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItemConfirm"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                  v-if="canManageProducts && !item.ManualProduct && !item.IsCashOut"
                  small
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  v-if="canManageProducts && !item.ManualProduct && !item.IsCashOut"
                  small
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary"> No product for this event </v-btn>
              </template>
            </v-data-table>

            <ProductImportDialog
              ref="importDialog"
              v-model="importDialog"
              :event-id="(selectedEvent && selectedEvent.EventId) || ''"
              :event-name="(selectedEvent && selectedEvent.EventName) || ''"
              @validate="handleProductImportValidate"
              @import="handleProductImport"
            />

            <CopyToStallholderDialog
              ref="copyDialog"
              v-model="copyDialog"
              :source-event-id="(selectedEvent && selectedEvent.EventId) || ''"
              :source-stallholder-id="
                (selectedStallHolder && selectedStallHolder.StallholderId) || ''
              "
              :category-ids="selectedProductCategoryIds"
              :product-ids="selectedProductIds"
              @copy="handleCopyTo"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import "izitoast/dist/css/iziToast.min.css"; // loading css
import iziToast from "izitoast/dist/js/iziToast.min.js"; // you have access to iziToast now
import { mapState, mapActions, mapMutations } from "vuex";
import CopyToStallholderDialog from "@/components/productManagement/CopyToStallholderDialog.vue";
import ProductImportDialog from "@/components/productManagement/ProductImportDialog.vue";
import { hasWrite, hasEventOrStallholderReadOrWrite } from "@/utils/permissions";

export default {
  components: {
    CopyToStallholderDialog,
    ProductImportDialog,
  },
  props: {
    productsData: {
      type: Object,
      default: () => ({
        products: [],
        productCategories: [],
        stallholderTags: [],
        productOptions: [],
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    copyDialog: false,
    importDialog: false,
    selectedProducts: [],
    productsTableOptions: {
      page: 1,
      itemsPerPage: 10,
    },

    selectedStall: "",
    stalls: [],
    stallProducts: [{ Stall: null, ShortName: "", Price: "" }],
    headers: [
      { text: "Product Name", value: "ProductName" },
      { text: "Short Name", value: "ShortName" },
      // { text: "Tag(s)", value: "TagIds" },
      { text: "Category", value: "CategoryName" },
      { text: "Price ($)", value: "Price" },
      { text: "Discount Surcharge (%)", value: "DiscountSurchargePercentage" },
      { text: "Standard Drinks", value: "StandardDrinks" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    editedIndex: -1,
    previousProductNameForShort: "",
    editedItem: {
      EventId: "",
      StallholderId: "",
      CategoryId: "",
      TagIds: [],
      ProductOptionIds: "",
      ProductName: "",
      ShortName: "",
      Price: "",
      DiscountSurchargePercentage: 0,
      StandardDrinks: "",
      GstFlag: true,
      DiscountSurchargeManager: false,
      DiscountSurchargeItem: false,
      MandatoryOptions: false,
      ManualProduct: false,
      IsCashOut: false,
    },
    defaultItem: {
      EventId: "",
      StallholderId: "",
      CategoryId: "",
      TagIds: [],
      ProductOptionIds: "",
      ProductName: "",
      ShortName: "",
      Price: "",
      DiscountSurchargePercentage: 0,
      StandardDrinks: "",
      GstFlag: true,
      DiscountSurchargeManager: false,
      DiscountSurchargeItem: false,
      MandatoryOptions: false,
      ManualProduct: false,
      IsCashOut: false,
    },

    ManualProductObj: {},
    ManualProduct: false,
    IsCashOutProductObj: {},
    IsCashOut: false,

    valid: true,
    selectedCategoryFilter: null,
  }),

  computed: {
    ...mapState("filter", ["globalEventFilter", "IsAdmin"]),
    ...mapState("admin", ["currentStallHolders", "currentStallholder"]),

    eventPermission() {
      return this.globalEventFilter?.Permission || "None";
    },

    stallholderPermission() {
      return this.currentStallholder?.Permission || "None";
    },

    canManageProducts() {
      return (
        this.IsAdmin ||
        hasWrite(this.eventPermission) ||
        hasWrite(this.stallholderPermission)
      );
    },

    canViewProducts() {
      return (
        this.IsAdmin ||
        hasEventOrStallholderReadOrWrite(
          this.eventPermission,
          this.stallholderPermission
        )
      );
    },

    allProducts() {
      if (!this.canViewProducts) {
        return [];
      }
      return this.productsData.products || [];
    },

    CategoryList() {
      return this.productsData.productCategories || [];
    },

    TagList() {
      // Product tags are event-level (API EventTags); StallholderTags is unused/empty
      return this.productsData.eventTags || [];
    },

    ProductOptionList() {
      return this.productsData.productOptions || [];
    },

    formTitle() {
      return this.editedIndex === -1 ? "New Product" : "Edit Product";
    },

    selectedEvent: {
      get() {
        return this.globalEventFilter;
      },
      set(value) {
        console.log("EVENT IS CHANGED MAKE API REQUEST", value);
      },
    },

    selectedStallHolder: {
      get() {
        return this.currentStallholder;
      },
      set(value) {
        this.setCurrentStallholder(value);
      },
    },

    filteredProducts() {
      if (
        !this.selectedCategoryFilter ||
        this.selectedCategoryFilter.CategoryId === ""
      ) {
        return this.allProducts.filter((product) => !product.Deleted);
      }
      return this.allProducts.filter(
        (product) =>
          product.CategoryId === this.selectedCategoryFilter.CategoryId &&
          !product.Deleted
      );
    },

    productsForTable() {
      return (this.filteredProducts || []).map((product) => ({
        ...product,
        CategoryName: this.getCategoryName(product.CategoryId),
      }));
    },

    copyableProducts() {
      return (this.productsForTable || []).filter((p) =>
        this.isProductCopyable(p)
      );
    },

    visibleCopyableProducts() {
      const page = this.productsTableOptions?.page || 1;
      const itemsPerPage = this.productsTableOptions?.itemsPerPage ?? 10;
      const list = this.productsForTable || [];
      const pageItems =
        itemsPerPage === -1
          ? list
          : list.slice((page - 1) * itemsPerPage, page * itemsPerPage);
      return pageItems.filter((p) => this.isProductCopyable(p));
    },

    allVisibleCopyableSelected() {
      const visible = this.visibleCopyableProducts;
      if (!visible.length) return false;
      const selectedIds = new Set(
        (this.selectedProducts || []).map((p) => p.ProductId)
      );
      return visible.every((p) => selectedIds.has(p.ProductId));
    },

    someVisibleCopyableSelected() {
      const selectedIds = new Set(
        (this.selectedProducts || []).map((p) => p.ProductId)
      );
      return this.visibleCopyableProducts.some((p) =>
        selectedIds.has(p.ProductId)
      );
    },

    selectedProductIds() {
      return (this.selectedProducts || [])
        .filter((p) => this.isProductCopyable(p))
        .map((p) => p.ProductId)
        .filter(Boolean);
    },

    // Unique categories belonging to selected products — also copied by the API
    selectedProductCategoryIds() {
      const ids = new Set();
      (this.selectedProducts || [])
        .filter((p) => this.isProductCopyable(p))
        .forEach((p) => {
          const catId = p.CategoryId;
          if (catId && catId !== "TBC") {
            ids.add(catId);
          }
        });
      return [...ids];
    },

    categoryFilterList() {
      const allCategoriesOption = {
        CategoryId: "",
        CategoryName: "All Categories",
      };
      return [allCategoriesOption, ...this.CategoryList];
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        // Ensure stalls are available when opening Add/Edit dialog
        const sh = this.selectedStallHolder;
        if (sh && sh.Stalls) {
          this.stalls = sh.Stalls;
        }
        if (this.editedIndex === -1) {
          this.previousProductNameForShort = "";
          this.stallProducts = [{ Stall: null, ShortName: "", Price: "" }];
        }
      } else {
        this.close();
      }
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    productsData: {
      handler(newData) {
        if (newData && newData.products) {
          // Update special product flags when data changes
          this.updateSpecialProductFlags(newData.products);
        }
      },
      immediate: true,
    },
    selectedProducts(value) {
      const copyable = (value || []).filter((p) => this.isProductCopyable(p));
      if (copyable.length !== (value || []).length) {
        this.selectedProducts = copyable;
      }
    },
  },

  methods: {
    isProductCopyable(item) {
      return !item?.ManualProduct && !item?.IsCashOut;
    },

    isProductSelected(item) {
      const id = item?.ProductId;
      if (id == null) return false;
      return (this.selectedProducts || []).some((p) => p.ProductId === id);
    },

    toggleProductSelected(item) {
      if (!this.isProductCopyable(item) || item?.ProductId == null) return;
      if (this.isProductSelected(item)) {
        this.selectedProducts = (this.selectedProducts || []).filter(
          (p) => p.ProductId !== item.ProductId
        );
      } else {
        this.selectedProducts = [...(this.selectedProducts || []), item];
      }
    },

    toggleSelectAllCopyable() {
      // Toggle from current state (don't trust checkbox event payload).
      // Only affect copyable rows on the current page — Manual/Cashout have
      // no checkbox, which breaks Vuetify's built-in select-all deselect.
      if (this.allVisibleCopyableSelected) {
        const visibleIds = new Set(
          this.visibleCopyableProducts.map((p) => p.ProductId)
        );
        this.selectedProducts = (this.selectedProducts || []).filter(
          (p) => !visibleIds.has(p.ProductId)
        );
      } else {
        const byId = new Map(
          (this.selectedProducts || []).map((p) => [p.ProductId, p])
        );
        this.visibleCopyableProducts.forEach((p) => {
          if (p.ProductId != null) byId.set(p.ProductId, p);
        });
        this.selectedProducts = [...byId.values()];
      }
    },

    ...mapActions("admin", [
      "createCategories",
      "copyProductsBatch",
      "productImport",
    ]),
    ...mapMutations("admin", ["setCurrentStallholder"]),

    updateSpecialProductFlags(products) {
      // Manual Product
      this.ManualProductObj = products.find(
        (product) => product.ManualProduct && !product.Deleted
      );
      this.ManualProduct = this.ManualProductObj?.ManualProduct ?? false;

      // CashOut Product
      this.IsCashOutProductObj = products.find(
        (product) => product.IsCashOut && !product.Deleted
      );
      this.IsCashOut = this.IsCashOutProductObj?.IsCashOut ?? false;
    },

    itemRowBackground: function (item) {
      return item.ManualProduct === true
        ? "indigo"
        : item.IsCashOut === true
        ? "indigo"
        : "";
    },

    getCategoryName: function (categoryId) {
      // Return empty string if no categoryId
      if (!categoryId) {
        return "";
      }

      // Find the category in CategoryList that matches the categoryId
      const category = this.CategoryList.find(
        (cat) => cat.CategoryId === categoryId
      );

      // Return CategoryName if found, otherwise return empty string
      return category ? category.CategoryName : "";
    },

    onProductNameInput(value) {
      // Edit: never overwrite Short Name when Product Name changes
      if (this.editedIndex !== -1) return;

      const nextName = value || "";
      const shortName = String(this.editedItem.ShortName || "").trim();
      const previousName = String(this.previousProductNameForShort || "");

      // Create: fill only when Short Name is empty or still matches last auto-fill
      if (shortName === "" || shortName === previousName) {
        this.editedItem.ShortName = nextName;
      }
      this.previousProductNameForShort = nextName;
    },

    handleCheckTags: function (tagIds) {
      // Check if tagIds exists and is an array
      if (!tagIds || !Array.isArray(tagIds) || tagIds.length === 0) {
        return [];
      }

      // Return matching tag objects so the combobox and save() both work
      return this.TagList.filter(function (tag) {
        return tagIds.some(function (tagId) {
          return tag.ProductTagId === tagId;
        });
      });
    },

    handleCheckProductOptionIds: function (OptionIds) {
      // Check if OptionIds exists and is an array
      if (!OptionIds || !Array.isArray(OptionIds) || OptionIds.length === 0) {
        return [];
      }

      var result = this.ProductOptionList.filter(function (o1) {
        return OptionIds.some(function (o2) {
          return o1.ProductOptionId === o2;
        });
      }).map(function (o) {
        return o.ProductOptionName;
      });
      return result;
    },

    handleChangeStallHolder: function (obj) {
      if (obj) {
        this.setCurrentStallholder(obj);
        this.stalls = obj.Stalls || [];
        this.selectedProducts = [];
        // Stall list changed — clear pending overrides so IDs stay valid
        this.stallProducts = [{ Stall: null, ShortName: "", Price: "" }];

        // Reset category filter to "All Categories" when stallholder changes
        this.selectedCategoryFilter = {
          CategoryId: "",
          CategoryName: "All Categories",
        };

        // Note: Data will be refreshed by parent component
      }
    },

    async handleCopyTo(payload, destination) {
      try {
        const response = await this.copyProductsBatch(payload);
        const copiedProducts = response?.CopiedProducts ?? 0;
        const copiedCategories = response?.CopiedCategories ?? 0;
        iziToast.success({
          title: "Copied",
          message: `Copied ${copiedProducts} product${
            copiedProducts === 1 ? "" : "s"
          } and ${copiedCategories} categor${
            copiedCategories === 1 ? "y" : "ies"
          } to ${destination.stallholder.StallholderName} (${
            destination.event.EventName
          }). Switch to that stallholder to view them.`,
          position: "topRight",
        });
        this.selectedProducts = [];
        this.copyDialog = false;
        this.$emit("refresh-data");
      } catch (err) {
        console.error("Copy products failed:", err);
        const message =
          err?.response?.data?.message ||
          err?.message ||
          "Copy failed. Please try again.";
        if (this.$refs.copyDialog) {
          this.$refs.copyDialog.setError(message);
        }
        iziToast.warning({
          title: "Copy failed",
          message,
          position: "topRight",
        });
      }
    },

    async handleProductImportValidate(payload) {
      try {
        const response = await this.productImport(payload);
        if (this.$refs.importDialog) {
          this.$refs.importDialog.setPreview(response);
        }
      } catch (err) {
        const message =
          err?.response?.data?.Message ||
          err?.message ||
          "Unable to validate the CSV.";
        if (this.$refs.importDialog) {
          this.$refs.importDialog.setError(message);
        }
      }
    },

    async handleProductImport(payload) {
      try {
        const response = await this.productImport(payload);
        const importedShId = (response?.ProductsToCreate || [])[0]
          ?.StallholderId;
        const importedSh = (this.currentStallHolders || []).find(
          (sh) => sh.StallholderId === importedShId
        );
        if (importedSh) {
          this.setCurrentStallholder(importedSh);
        }
        this.productsTableOptions = {
          ...this.productsTableOptions,
          page: 1,
        };
        this.selectedCategoryFilter = {
          CategoryId: "",
          CategoryName: "All Categories",
        };
        iziToast.success({
          title: "Import Products",
          message: `Created ${response?.ImportedProducts || 0} product${
            (response?.ImportedProducts || 0) === 1 ? "" : "s"
          }.`,
          position: "topRight",
        });
        this.importDialog = false;
        this.$emit("refresh-data");
      } catch (err) {
        const message =
          err?.response?.data?.Message ||
          err?.message ||
          "Import failed. Please try again.";
        if (this.$refs.importDialog) {
          this.$refs.importDialog.setError(message);
        }
      }
    },

    toggleDiscountSurchargeFields() {
      if (this.editedItem.DiscountSurchargeItem) {
        // Set default values for discount surcharge
        this.editedItem.Price = null;
        this.editedItem.StandardDrinks = null;
        this.editedItem.GstFlag = false;
        this.editedItem.CategoryId = "TBC";
        this.editedItem.TagIds = [];
        this.editedItem.ProductOptionIds = [];
        // Set default name if creating new discount surcharge item
        if (!this.editedItem.ProductName) {
          this.editedItem.ProductName = "Discount Surcharge Item";
          this.editedItem.ShortName = "Discount Surcharge Item";
        }
      } else {
        // Clear discount surcharge specific fields
        this.editedItem.DiscountSurchargePercentage = null;
        this.editedItem.DiscountSurchargeManager = false;
        this.editedItem.CategoryId = null;
        // Set default name if creating new discount surcharge item
        if (this.editedItem.ProductName === "Discount Surcharge Item") {
          this.editedItem.ProductName = "";
        }
        if (this.editedItem.ShortName === "Discount Surcharge Item") {
          this.editedItem.ShortName = "";
        }
        // Reset to default values for regular products
        this.editedItem.Price = null;
        this.editedItem.StandardDrinks = null;
        this.editedItem.GstFlag = true;
      }
    },

    editItem(item) {
      this.editedIndex = this.allProducts.findIndex(
        (p) => p.ProductId === item.ProductId
      );
      console.log("item");
      console.log(item);

      this.editedItem.EventId = item.EventId;
      this.editedItem.StallholderId = item.StallholderId;

      this.editedItem.CategoryId = this.CategoryList.filter((element) => {
        return element.CategoryId === item.CategoryId;
      });
      this.editedItem.CategoryId =
        this.editedItem.CategoryId.length > 0
          ? this.editedItem.CategoryId[0]
          : null;

      this.editedItem.TagIds = this.handleCheckTags(item.TagIds);
      this.editedItem.ProductOptionIds = this.handleCheckProductOptionIds(
        item.ProductOptionIds
      );

      this.editedItem.ProductId = item.ProductId;
      this.editedItem.ProductName = item.ProductName;
      this.editedItem.ShortName = item.ShortName;
      this.editedItem.Price = item.Price;
      this.editedItem.DiscountSurchargePercentage =
        item.DiscountSurchargePercentage || 0;
      this.editedItem.DiscountSurchargeManager =
        item.DiscountSurchargeManager || false;
      this.editedItem.DiscountSurchargeItem =
        item.DiscountSurchargeItem || false;
      this.editedItem.MandatoryOptions = item.MandatoryOptions;
      this.editedItem.StandardDrinks = item.StandardDrinks;
      this.editedItem.GstFlag = item.GstFlag !== false;

      this.loadStallProductsFromItem(item);

      let selected = this.currentStallHolders.filter((element) => {
        return element.StallholderId === item.StallholderId;
      });

      if (selected.length > 0) {
        this.setCurrentStallholder(selected[0]);
        this.stalls = selected[0].Stalls || [];
        // Re-map stall objects once stalls are available
        this.loadStallProductsFromItem(item);
      }

      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.allProducts.findIndex(
        (p) => p.ProductId === item.ProductId
      );
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      try {
        if (this.editedItem.StallholderId) {
          let event_item = [
            {
              Type: "product",
              Action: "delete",
              Properties: this.editedItem,
            },
          ];

          let submitEvent = {
            event_items: event_item,
          };
          this.createCategories(submitEvent)
            .then((response) => {
              console.log("response");
              console.log(response);

              iziToast.success({
                title: "Product",
                message: "Successfully delete record!",
                position: "topRight",
              });

              this.$emit("refresh-data");
            })
            .catch((err) => {
              console.log("err");
              console.log(err);

              iziToast.warning({
                title: "Stallholder",
                message: "Fail to delete record!",
                position: "topRight",
              });

              this.$emit("refresh-data");
            });
        }
      } catch (e) {
        console.log(e);
      }

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.previousProductNameForShort = "";
        this.stallProducts = [{ Stall: null, ShortName: "", Price: "" }];
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    loadStallProductsFromItem(item) {
      const rows = Array.isArray(item?.StallProducts) ? item.StallProducts : [];
      if (!rows.length) {
        this.stallProducts = [{ Stall: null, ShortName: "", Price: "" }];
        return;
      }
      this.stallProducts = rows.map((row) => {
        const stallId = row.StallId || row.StallIds || null;
        const stallObj =
          (this.stalls || []).find((s) => s.StallId === stallId) ||
          (stallId ? { StallId: stallId, StallName: stallId } : null);
        return {
          Stall: stallObj,
          ShortName: row.ShortName != null ? row.ShortName : "",
          Price:
            row.Price !== undefined && row.Price !== null && row.Price !== ""
              ? row.Price
              : "",
        };
      });
    },

    availableStallsForOverride(index) {
      const used = new Set(
        (this.stallProducts || [])
          .map((row, i) =>
            i !== index && row.Stall && row.Stall.StallId
              ? row.Stall.StallId
              : null
          )
          .filter(Boolean)
      );
      return (this.stalls || []).map((stall) => ({
        ...stall,
        disabled: used.has(stall.StallId),
      }));
    },

    addStallProductRow() {
      const last = this.stallProducts[this.stallProducts.length - 1];
      if (!last || !last.Stall || !last.Stall.StallId) {
        iziToast.warning({
          title: "Stall overrides",
          message: "Select a stall on the current row before adding another.",
          position: "topRight",
        });
        return;
      }
      this.stallProducts.push({ Stall: null, ShortName: "", Price: "" });
    },

    removeStallProductRow(index) {
      if (this.stallProducts.length <= 1) {
        this.stallProducts = [{ Stall: null, ShortName: "", Price: "" }];
        return;
      }
      this.stallProducts.splice(index, 1);
    },

    buildStallProductsPayload() {
      return (this.stallProducts || [])
        .filter((row) => row.Stall && row.Stall.StallId)
        .map((row) => {
          const out = { StallId: row.Stall.StallId };
          if (row.ShortName !== undefined && String(row.ShortName).trim() !== "") {
            out.ShortName = String(row.ShortName).trim();
          }
          if (
            row.Price !== undefined &&
            row.Price !== null &&
            String(row.Price).trim() !== ""
          ) {
            const num = Number(row.Price);
            if (!Number.isNaN(num)) out.Price = num;
          }
          return out;
        })
        .filter((row) => row.ShortName !== undefined || row.Price !== undefined);
    },

    save() {
      console.log("Starting save()", this.editedItem);
      if (this.$refs.form.validate()) {
        try {
          if (this.$refs.form.validate()) {
            this.editedItem.EventId = this.selectedEvent.EventId;
            this.editedItem.StallholderId =
              this.selectedStallHolder.StallholderId;

            // Handle discount surcharge items
            if (this.editedItem.DiscountSurchargeItem) {
              // Ensure required fields for discount surcharge
              if (!this.editedItem.DiscountSurchargePercentage) {
                iziToast.warning({
                  title: "Validation Error",
                  message: "Discount Surcharge (%) is required!",
                  position: "topRight",
                });
                return;
              }
              // Set default values for discount surcharge items
              this.editedItem.Price = null;
              this.editedItem.StandardDrinks = null;
              this.editedItem.GstFlag = false;
              this.editedItem.CategoryId = "TBC";
              this.editedItem.TagIds = [];
              this.editedItem.ProductOptionIds = [];
              this.editedItem.StallProducts = [];
            } else {
              // Handle regular products
              this.editedItem.CategoryId =
                this.editedItem.CategoryId &&
                this.editedItem.CategoryId.CategoryId;
              this.editedItem.TagIds = (this.editedItem.TagIds || []).map((obj) => {
                return typeof obj === "string" ? obj : obj.ProductTagId;
              }).filter(Boolean);
              console.log(
                "save () this.editedItem.ProductOptionIds: ",
                this.editedItem.ProductOptionIds
              );
              if (this.editedItem.ProductOptionIds !== "") {
                this.editedItem.ProductOptionIds =
                  this.editedItem.ProductOptionIds.map((obj) => {
                    return obj.ProductOptionId;
                  });
              } else {
                delete this.editedItem.ProductOptionIds;
              }
              // Clear discount surcharge fields for regular products
              this.editedItem.DiscountSurchargePercentage = 0;
              this.editedItem.DiscountSurchargeManager = false;
              this.editedItem.StallProducts = this.buildStallProductsPayload();
            }

            console.log("editedItem");
            console.log(this.editedItem);
            let event_item = [
              {
                Type: "product",
                Action: this.editedIndex === -1 ? "Create" : "Edit",
                Properties: this.editedItem,
              },
            ];

            let submitEvent = {
              event_items: event_item,
            };
            console.log("submitEvent");
            console.log(submitEvent);
            this.createCategories(submitEvent)
              .then((response) => {
                console.log("response");
                console.log(response);

                iziToast.success({
                  title: "Product",
                  message: "Successfully inserted record!",
                  position: "topRight",
                });

                this.$emit("refresh-data");
              })
              .catch((err) => {
                console.log("err");
                console.log(err);

                iziToast.warning({
                  title: "Product",
                  message: "Fail to inserted record!",
                  position: "topRight",
                });
              });
          }
        } catch (e) {
          console.log(e);
        }
        this.close();
      }
    },
    // Manual Product
    handleCreateManualProduct: function () {
      if (!this.ManualProduct) {
        try {
          let submitEvent = {};
          let isAction = "Create";
          const foundManualProduct = this.allProducts.find(
            (product) => product.ManualProduct && product.Deleted
          );
          if (foundManualProduct) {
            submitEvent = { ...foundManualProduct };
            isAction = "Edit";
          } else {
            submitEvent.ManualProduct = true;
            submitEvent.EventId = this.selectedEvent.EventId;
            submitEvent.StallholderId = this.selectedStallHolder.StallholderId;
            submitEvent.CategoryId = "TBC";
            submitEvent.ProductName = "Manual Product";
            submitEvent.ShortName = "Manual Product";
          }
          submitEvent.Deleted = false;
          this.handleSubmit(submitEvent, isAction);
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          let submitEvent = {};
          submitEvent.EventId = this.selectedEvent.EventId;
          submitEvent.StallholderId = this.selectedStallHolder.StallholderId;
          submitEvent.ProductId = this.ManualProductObj.ProductId;

          let isAction = "Delete";
          this.handleSubmit(submitEvent, isAction);
        } catch (e) {
          console.log(e);
        }
      }
    },
    // IsCashOut
    handleCreateIsCashOut: function () {
      if (!this.IsCashOut) {
        try {
          let isAction = "Create";
          let submitEvent = {};
          const foundCashOutProduct = this.allProducts.find(
            (product) => product.IsCashOut && product.Deleted
          );
          if (foundCashOutProduct) {
            submitEvent = { ...foundCashOutProduct };
            isAction = "Edit";
          } else {
            submitEvent.IsCashOut = true;
            submitEvent.EventId = this.selectedEvent.EventId;
            submitEvent.StallholderId = this.selectedStallHolder.StallholderId;
            submitEvent.CategoryId = "TBC";
            submitEvent.ProductName = "Cashout";
            submitEvent.ShortName = "Cashout";
          }
          submitEvent.Deleted = false;

          this.handleSubmit(submitEvent, isAction);
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          // So this just updates the deleted flag????
          let submitEvent = {};
          submitEvent.EventId = this.selectedEvent.EventId;
          submitEvent.StallholderId = this.selectedStallHolder.StallholderId;
          submitEvent.ProductId = this.IsCashOutProductObj.ProductId;

          let isAction = "Delete";
          this.handleSubmit(submitEvent, isAction);
        } catch (e) {
          console.log(e);
        }
      }
    },
    handleSubmit: function (obj, action) {
      try {
        let event_item = [
          {
            Type: "product",
            Action: action,
            Properties: obj,
          },
        ];

        let submit = {
          event_items: event_item,
        };
        this.createCategories(submit)
          .then((response) => {
            console.log("response");
            console.log(response);

            iziToast.success({
              title: "Product",
              message: "Successfully " + action + " record!",
              position: "topRight",
            });

            this.$emit("refresh-data");
          })
          .catch((err) => {
            console.log("err");
            console.log(err);

            iziToast.warning({
              title: "Product",
              message: "Fail to inserted record!",
              position: "topRight",
            });
          });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style scoped>
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
</style>
